var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15852_21743)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15852_21743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.46652C5.33333 5.91423 4.88562 5.46652 4.33333 5.46652C3.78105 5.46652 3.33333 5.91424 3.33333 6.46652L3.33333 16.0523L1.70711 14.4261C1.31658 14.0356 0.683417 14.0356 0.292893 14.4261C-0.0976311 14.8166 -0.0976311 15.4498 0.292893 15.8403L3.62623 19.1736C4.01675 19.5642 4.64992 19.5642 5.04044 19.1736L8.37377 15.8403C8.7643 15.4498 8.7643 14.8166 8.37377 14.4261C7.98325 14.0356 7.35008 14.0356 6.95956 14.4261L5.33333 16.0523L5.33333 6.46652Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 16.9577C10.8 17.5332 11.2262 17.9998 11.7519 17.9998H23.0481C23.5738 17.9998 24 17.5332 24 16.9577C24 16.3822 23.5738 15.9156 23.0481 15.9156H11.7519C11.2262 15.9156 10.8 16.3822 10.8 16.9577Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5.84191C10.8 6.41745 11.2262 6.88402 11.7519 6.88402H14.7288C15.2546 6.88402 15.6808 6.41745 15.6808 5.84191C15.6808 5.26637 15.2546 4.7998 14.7288 4.7998H11.7519C11.2262 4.7998 10.8 5.26637 10.8 5.84191Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7519 12.4419C11.2262 12.4419 10.8 11.9753 10.8 11.3998C10.8 10.8243 11.2262 10.3577 11.7519 10.3577H19.8058C20.3315 10.3577 20.7577 10.8243 20.7577 11.3998C20.7577 11.9753 20.3315 12.4419 19.8058 12.4419H11.7519Z",
    fill: "#71869D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15852_21743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15852_21743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortAsc);
export default __webpack_public_path__ + "static/media/iconSortAsc.dd306aee9232be7904303a62bebd1f95.svg";
export { ForwardRef as ReactComponent };